import { render, staticRenderFns } from "./AdminPatterns.vue?vue&type=template&id=931f073e&scoped=true"
import script from "./AdminPatterns.vue?vue&type=script&lang=js"
export * from "./AdminPatterns.vue?vue&type=script&lang=js"
import style0 from "./AdminPatterns.vue?vue&type=style&index=0&id=931f073e&prod&lang=scss"
import style1 from "./AdminPatterns.vue?vue&type=style&index=1&id=931f073e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931f073e",
  null
  
)

export default component.exports